const record = {
    topLeft: 'top-start',
    topRight: 'top-end',
    bottomLeft: 'bottom-start',
    bottomRight: 'bottom-end',
    leftTop: 'left-start',
    leftBottom: 'left-end',
    rightTop: 'right-start',
    rightBottom: 'right-end',
};
export function normalizePlacement(placement) {
    return record[placement] ?? placement;
}
